"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardBlockedDomainsOption')(function discardBlockedDomainsOption(state) {
    var optionState = state.optionState;
    optionState.blockedDomains = null;
}));
//# sourceMappingURL=discardBlockedDomainsOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-blocked-domains-option/lib/actions/discardBlockedDomainsOption.js
// module id = 5016
// module chunks = 2